import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MusicNoteHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.627 14.078c2.031-1.67 4.06-4.113 4.06-6.83 0-2.3-1.862-4.587-4.16-4.587a4.16 4.16 0 0 0-3.84 2.581 4.16 4.16 0 0 0-3.846-2.581c-2.808 0-4.969 3.431-3.856 6.112m-.216 8.958a3.2 3.2 0 0 0-.956-.142c-1.38 0-2.5.839-2.5 1.875s1.119 1.875 2.5 1.875 2.5-.839 2.5-1.875v-9.12l8-1v8.745c0 1.036-1.119 1.875-2.5 1.875s-2.5-.839-2.5-1.875c0-1.293 1.746-2.28 3.566-1.709m-6.566-3.036 6.462-.808"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MusicNoteHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
